import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const InfoCircle = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M12 10.75V16.25"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
      />
      <circle cx="12" cy="7.75" r="1" fill={color} />
    </BaseIcon>
  ),
);

InfoCircle.displayName = 'InfoCircle';
